

// import React from 'react';
// import { NavLink } from 'react-router-dom';
// import Header from './components/Header';
// import FooterPage from './components/FooterPage';
// import homegif from './Images/homegif.gif';
// import { FaInstagram, FaYoutube } from 'react-icons/fa'; // Import Instagram and YouTube icons
// import Slider from 'react-slick';
// import { FaUsers, FaWallet, FaLock, FaBell } from 'react-icons/fa';

// const Home = () => {
//   const Images = [
//     "https://www.upfluence.com/wp-content/uploads/elementor/thumbs/Client-Logo-Netflix-quah560nq2rlgrugsu9vf81sgznpnc8uqcmrp27vbs.png",
//     "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQaGtStAl2CAgEhUqKJFPnsHKrFKxUht2t68F2VkzO8xXeAqToU",
//     "https://encrypted-tbn3.gstatic.com/images?q=tbn:ANd9GcSvVO6uW1MoLAPZcNxJK22DT9AE85EO3boos7ZZTThXc2iLOtnL",
//   ];

//   const settings = {
//     dots: false,
//     infinite: true,
//     speed: 500,
//     slidesToShow: 4,
//     slidesToScroll: 1,
//     autoplay: true,
//     autoplaySpeed: 2000,
//   };

//   return (
//     <div style={{ backgroundColor: '#fff', padding: '20px' }}>
//       <Header />

//       {/* Hero Section */}
//       <div style={{ width: '80%', margin: 'auto', marginTop: '40px' }}>
//         <div style={{ display: 'flex', alignItems: 'center' }}>
//           <div style={{ flex: 1 }}>
//             <h1 style={{ fontSize: '36px', fontWeight: 'bold' }}>
//               Hypebox generates sales to brands via micro-influencers
//             </h1>
//             <p style={{ fontSize: '18px', marginTop: '20px' }}>
//               Generate sales, attract customers and increase brand awareness.{' '}
//               <b style={{ fontWeight: 'bold' }}>Pay only for results.</b>
//             </p>
//           </div>
//           <img src={homegif} style={{ width: '30%', marginLeft: 'auto' }} alt="Home GIF" />
//         </div>
//       </div>

//       {/* Search Bar with Icons and Buttons */}
//       <div
//         style={{
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'space-between',
//           border: '1px solid #ccc',
//           borderRadius: '5px',
//           padding: '5px',
//           maxWidth: '600px',
//           margin: '0 auto',
//           backgroundColor: '#fff',
//           borderRadius: '40px',
//         }}
//       >
//         {/* Social Media Icons */}
//         <div style={{ display: 'flex', alignItems: 'center', gap: '10px', paddingLeft: '20px' }}>
//           <a
//             href="https://instagram.com"
//             target="_blank"
//             rel="noopener noreferrer"
//             style={{ color: '#E4405F', fontSize: '24px' }}
//           >
//             <FaInstagram />
//           </a>
//           <a
//             href="https://youtube.com"
//             target="_blank"
//             rel="noopener noreferrer"
//             style={{ color: '#FF0000', fontSize: '24px' }}
//           >
//             <FaYoutube />
//           </a>
//         </div>

//         {/* Search Input and Button */}
//         <div style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
//           <input
//             type="text"
//             placeholder="Search..."
//             style={{
//               width: '100%',
//               padding: '10px',
//               border: 'none',
//               borderRadius: '5px 0 0 5px',
//               color: '#000000',
//               outline: 'none',
//             }}
//           />
//           <button
//             style={{
//               border: 'none',
//               padding: '10px 15px',
//               backgroundColor: '#007bff',
//               color: '#fff',
//               borderRadius: '0 5px 5px 0',
//               cursor: 'pointer',
//               alignItems: 'center',
//               fontSize: '16px',
//               borderRadius: '25px',
//             }}
//           >
//             Search
//           </button>
//         </div>
//       </div>

//       <div className="flex pt-8 text-lg" style={{ justifyContent: 'center' }}>
//         <NavLink to="/BrandIntro">
//           <div
//             className="mr-5 bg-yellow-300 px-7 py-3 hover:bg-gray-400 ease-in duration-200 rounded"
//             style={{ textAlign: 'center' }}
//           >
//             I'm a Brand
//           </div>
//         </NavLink>
//         <NavLink to="/InfluencerIntro">
//           <div
//             className="mr-5 bg-yellow-800 px-7 py-3 hover:bg-gray-400 ease-in duration-200 text-white rounded"
//             style={{ textAlign: 'center' }}
//           >
//             I'm a Creator
//           </div>
//         </NavLink>
//       </div>

//       {/* Slider Section */}
//       <div style={{ width: '90%', margin: '30px auto' }}>
//         <Slider {...settings}>
//           {Images.map((logo, index) => (
//             <div key={index} className="slide">
//               <img
//                 src={logo}
//                 alt={`Logo ${index + 1}`}
//                 style={{
//                   width: '100px',
//                   height: '50px',
//                   objectFit: 'contain',
//                   display: 'block',
//                   margin: 'auto',
//                 }}
//               />
//             </div>
//           ))}
//         </Slider>
//       </div>

//       {/* Hypebox for Brands Section */}
//       <div style={{ backgroundColor: '#FFD700', padding: '50px 20px', textAlign: 'center' }}>
//         <h2 style={{ fontSize: '32px', color: '#000', fontWeight: 'bold', marginBottom: '20px' }}>
//           HYPEBOX FOR BRANDS
//         </h2>

//         {/* Cards Container */}
//         <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '20px' }}>
//           {[
//             { icon: <FaUsers size={50} />, title: '25k+', text: 'Micro-influencers on the platform.' },
//             { icon: <FaWallet size={50} />, title: '12M+', text: 'Leads and sales generated for clients.' },
//             { icon: <FaLock size={50} />, title: '4', text: 'Influence Marketing Managers.' },
//             { icon: <FaBell size={50} />, title: '120+', text: 'Happy clients with always-on campaigns.' }
//           ].map((item, index) => (
//             <div
//               key={index}
//               style={{
//                 backgroundColor: '#fff',
//                 padding: '20px',
//                 borderRadius: '10px',
//                 textAlign: 'center',
//                 width: '250px',
//                 boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
//                 transition: 'transform 0.3s ease-in-out',
//               }}
//               onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.05)')}
//               onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
//             >
//               {item.icon}
//               <h3 style={{ fontWeight: 'bold', color: '#333', marginTop: '10px' }}>{item.title}</h3>
//               <p style={{ color: '#555', fontSize: '14px' }}>{item.text}</p>
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* Discover Influencers Section */}
//       <section
//         id="section1"
//         style={{
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'space-between',
//           padding: '50px 10%',
//         }}
//       >
//         <div style={{ flex: 1, paddingRight: '20px' }}>
//           <h2 style={{ fontSize: '28px', fontWeight: 'bold' }}>Discover Influencers</h2>
//           <p style={{ fontSize: '16px', marginTop: '10px' }}>
//             Explore thousands of influencers that match your brand’s style and goals. Use advanced filters to refine your search.
//           </p>
//           <ul style={{ marginTop: '10px', paddingLeft: '20px' }}>
//             <li>Search by niche</li>
//             <li>Audience demographics</li>
//             <li>Platform performance</li>
//           </ul>
//         </div>
//         <div style={{ flex: 1 }}>
//           <img
//             src="https://cdn.dribbble.com/userupload/4239565/file/original-335442382efc15db6525c08d4207c7a5.png?format=webp&resize=400x300&vertical=center"
//             alt="Discover Influencers"
//             style={{ width: '100%', borderRadius: '10px' }}
//           />
//         </div>
//       </section>

//       {/* Manage Campaigns Section */}
//       <section
//         id="section2"
//         style={{
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'space-between',
//           padding: '50px 10%',
//           backgroundColor: '#f8f8f8',
//         }}
//       >
//         <div style={{ flex: 1 }}>
//           <img
//             src="https://cdn.dribbble.com/users/3517342/screenshots/20506922/media/dfec782cfc6e9d1e784aaaa7ee1e9201.png?format=webp&resize=400x300&vertical=center"
//             alt="Manage Campaigns"
//             style={{ width: '100%', borderRadius: '10px' }}
//           />
//         </div>
//         <div style={{ flex: 1, paddingLeft: '20px' }}>
//           <h2 style={{ fontSize: '28px', fontWeight: 'bold' }}>Manage Campaigns</h2>
//           <p style={{ fontSize: '16px', marginTop: '10px' }}>
//             Track and manage influencer marketing campaigns seamlessly with real-time data and insights.
//           </p>
//           <ul style={{ marginTop: '10px', paddingLeft: '20px' }}>
//             <li>Track key metrics</li>
//             <li>Collaborate effectively</li>
//             <li>Optimize campaigns</li>
//           </ul>
//         </div>
//       </section>

//       {/* Footer */}
//       <FooterPage />
//     </div>
//   );
// };

// export default Home;





// import React, { useEffect } from 'react';
// import { FaInstagram, FaYoutube } from 'react-icons/fa';
// import { NavLink } from 'react-router-dom';
// import Slider from 'react-slick';
// import { toast } from 'react-toastify';
// import FooterPage from './components/FooterPage';
// import Header from './components/Header';
// import homegif from './Images/homegif.gif';

// const Home = () => {
//   useEffect(() => {
//     // Check if the URL contains a code
//     const queryParams = new URLSearchParams(window.location.search);
//     const authCode = queryParams.get('code');

//     if (authCode) {
//       // If the URL contains 'code', send it to the backend to get an access tokenss
//       sendTokenRequest(authCode)
//         .then((data) => {
//           if (data?.access_token) {
//             localStorage.setItem('instagramAccessToken', data.access_token);
//             console.log('Access Token:', data.access_token);

//             toast.success('Access token saved successfully');
//           } else {
//             toast.error('Failed to retrieve access token from backend');
//           }
//         })
//         .catch((error) => {
//           console.error('Error sending token request:', error);
//           toast.error('Failed to fetch access token');
//         });
//     }
//   }, []);

//   const sendTokenRequest = (code) => {
//     return fetch("https://server-side-influencer-production.up.railway.app/instagram/token", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({
//         appId: '1366779784736329', // Your Instagram App Client IDs
//         appSecret: '079c7141825d53c3d8888a5c09ee71e9', // Your Instagram App Client Secrets
//         grant_type: 'authorization_code',
//         redirectUri: 'https://influencer-marketing-hub.vercel.app/', // Your Redirect URI
//         code: code, // The code from the URL
//       }),
//     })
//       .then((response) => response.json())
//       .then((data) => {
//         console.log("Token response:", data);
//         return data;
//       })
//       .catch((error) => {
//         console.error("Error fetching token:", error);
//         throw error;
//       });
//   };

//   const Images = [
//     "https://www.upfluence.com/wp-content/uploads/elementor/thumbs/Client-Logo-Netflix-quah560nq2rlgrugsu9vf81sgznpnc8uqcmrp27vbs.png",
//     "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQaGtStAl2CAgEhUqKJFPnsHKrFKxUht2t68F2VkzO8xXeAqToU",
//     "https://encrypted-tbn3.gstatic.com/images?q=tbn:ANd9GcSvVO6uW1MoLAPZcNxJK22DT9AE85EO3boos7ZZTThXc2iLOtnL",
//   ];

//   const settings = {
//     dots: false,
//     infinite: true,
//     speed: 500,
//     slidesToShow: 4,
//     slidesToScroll: 1,
//     autoplay: true,
//     autoplaySpeed: 2000,
//   };

//   return (
//     <div style={{ backgroundColor: '#fff', padding: '20px' }}>
//       <Header />

//       {/* Hero Section */}
//       <div style={{ width: '80%', margin: 'auto', marginTop: '40px' }}>
//         <div style={{ display: 'flex', alignItems: 'center' }}>
//           <div style={{ flex: 1 }}>
//             <h1 style={{ fontSize: '36px', fontWeight: 'bold' }}>
//               Hypebox generates sales to brands via micro-influencers
//             </h1>
//             <p style={{ fontSize: '18px', marginTop: '20px' }}>
//               Generate sales, attract customers and increase brand awareness.{' '}
//               <b style={{ fontWeight: 'bold' }}>Pay only for results.</b>
//             </p>
//           </div>
//           <img src={homegif} style={{ width: '30%', marginLeft: 'auto' }} alt="Home GIF" />
//         </div>
//       </div>

//       {/* Search Bar with Icons and Buttons */}
//       <div
//         style={{
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'space-between',
//           border: '1px solid #ccc',
//           borderRadius: '5px',
//           padding: '5px',
//           maxWidth: '600px',
//           margin: '0 auto',
//           backgroundColor: '#fff',
//           borderRadius: '40px',
//         }}
//       >
//         {/* Social Media Icons */}
//         <div style={{ display: 'flex', alignItems: 'center', gap: '10px', paddingLeft: '20px' }}>
//           <a
//             href="https://instagram.com"
//             target="_blank"
//             rel="noopener noreferrer"
//             style={{ color: '#E4405F', fontSize: '24px' }}
//           >
//             <FaInstagram />
//           </a>
//           <a
//             href="https://youtube.com"
//             target="_blank"
//             rel="noopener noreferrer"
//             style={{ color: '#FF0000', fontSize: '24px' }}
//           >
//             <FaYoutube />
//           </a>
//         </div>

//         {/* Search Input and Button */}
//         <div style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
//           <input
//             type="text"
//             placeholder="Search..."
//             style={{
//               width: '100%',
//               padding: '10px',
//               border: 'none',
//               borderRadius: '5px 0 0 5px',
//               color: '#000000',
//               outline: 'none',
//             }}
//           />
//           <button
//             style={{
//               border: 'none',
//               padding: '10px 15px',
//               backgroundColor: '#007bff',
//               color: '#fff',
//               borderRadius: '0 5px 5px 0',
//               cursor: 'pointer',
//               alignItems: 'center',
//               fontSize: '16px',
//               borderRadius: '25px',
//             }}
//           >
//             Search
//           </button>
//         </div>
//       </div>

//       <div className="flex pt-8 text-lg" style={{ justifyContent: 'center' }}>
//         <NavLink to="/BrandIntro">
//           <div
//             className="mr-5 bg-yellow-300 px-7 py-3 hover:bg-gray-400 ease-in duration-200 rounded"
//             style={{ textAlign: 'center' }}
//           >
//             I'm a Brand
//           </div>
//         </NavLink>
//         <NavLink to="/InfluencerIntro">
//           <div
//             className="mr-5 bg-yellow-800 px-7 py-3 hover:bg-gray-400 ease-in duration-200 text-white rounded"
//             style={{ textAlign: 'center' }}
//           >
//             I'm a Creator
//           </div>
//         </NavLink>
//       </div>

//       {/* Slider Section */}
//       <div style={{ width: '90%', margin: '30px auto' }}>
//         <Slider {...settings}>
//           {Images.map((logo, index) => (
//             <div key={index} className="slide">
//               <img
//                 src={logo}
//                 alt={`Logo ${index + 1}`}
//                 style={{
//                   width: '100px',
//                   height: '50px',
//                   objectFit: 'contain',
//                   display: 'block',
//                   margin: 'auto',
//                 }}
//               />
//             </div>
//           ))}
//         </Slider>
//       </div>

//       {/* Hypebox for Brands Section */}
//       <div style={{ backgroundColor: '#FFD700', padding: '50px 20px', textAlign: 'center' }}>
//         <h2 style={{ fontSize: '32px', color: '#000', fontWeight: 'bold', marginBottom: '20px' }}>
//           HYPEBOX FOR BRANDS
//         </h2>

//         {/* Cards Container */}
//         <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '20px' }}></div>
//       </div>

//       {/* Footer */}
//       <FooterPage />
//     </div>
//   );
// };

// export default Home;




// import React, { useEffect } from 'react';
// import { FaInstagram, FaYoutube } from 'react-icons/fa';
// import { NavLink } from 'react-router-dom';
// import Slider from 'react-slick';
// import { toast } from 'react-toastify';
// import FooterPage from './components/FooterPage';
// import Header from './components/Header';
// import homegif from './Images/homegif.gif';

// const Home = () => {
//   useEffect(() => {
//     // Get the current URL
//     const currentUrl = window.location.href;

//     // Remove any part after "#" (split the URL at "#")
//     const cleanUrl = currentUrl.split('#')[0];  // This removes anything after `#`

//     // Extract the query string from the cleaned URL (before the #)
//     const queryParams = new URLSearchParams(cleanUrl.split('?')[1]);

//     // Extract the auth code from the URL parameters
//     const authCode = queryParams.get('code');

//     if (authCode) {
//       // If the URL contains 'code', send it to the backend to get an access token
//       sendTokenRequest(authCode)
//         .then((data) => {
//           if (data?.access_token) {
//             localStorage.setItem('instagramAccessToken', data.access_token);
//             console.log('Access Token:', data.access_token);

//             toast.success('Access token saved successfully');
//           } else {
//             toast.error('Failed to retrieve access token from backend');
//           }
//         })
//         .catch((error) => {
//           console.error('Error sending token request:', error);
//           toast.error('Failed to fetch access token');
//         });
//     }
//   }, []);

//   const sendTokenRequest = (code) => {
//     return fetch("https://server-side-influencer-production.up.railway.app/instagram/token", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({
//         appId: '1366779784736329', // Your Instagram App Client IDs
//         appSecret: '079c7141825d53c3d8888a5c09ee71e9', // Your Instagram App Client Secrets
//         grant_type: 'authorization_code',
//         redirectUri: 'https://influencer-marketing-hub.vercel.app/', // Your Redirect URI
//         code: code, // The code from the URL (no fragment part)
//       }),
//     })
//       .then((response) => response.json())
//       .then((data) => {
//         console.log("Token response:", data);
//         return data;
//       })
//       .catch((error) => {
//         console.error("Error fetching token:", error);
//         throw error;
//       });
//   };

//   const Images = [
//     "https://www.upfluence.com/wp-content/uploads/elementor/thumbs/Client-Logo-Netflix-quah560nq2rlgrugsu9vf81sgznpnc8uqcmrp27vbs.png",
//     "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQaGtStAl2CAgEhUqKJFPnsHKrFKxUht2t68F2VkzO8xXeAqToU",
//     "https://encrypted-tbn3.gstatic.com/images?q=tbn:ANd9GcSvVO6uW1MoLAPZcNxJK22DT9AE85EO3boos7ZZTThXc2iLOtnL",
//   ];

//   const settings = {
//     dots: false,
//     infinite: true,
//     speed: 500,
//     slidesToShow: 4,
//     slidesToScroll: 1,
//     autoplay: true,
//     autoplaySpeed: 2000,
//   };

//   return (
//     <div style={{ backgroundColor: '#fff', padding: '20px' }}>
//       <Header />

//       {/* Hero Section */}
//       <div style={{ width: '80%', margin: 'auto', marginTop: '40px' }}>
//         <div style={{ display: 'flex', alignItems: 'center' }}>
//           <div style={{ flex: 1 }}>
//             <h1 style={{ fontSize: '36px', fontWeight: 'bold' }}>
//               Hypebox generates sales to brands via micro-influencers
//             </h1>
//             <p style={{ fontSize: '18px', marginTop: '20px' }}>
//               Generate sales, attract customers and increase brand awareness.{' '}
//               <b style={{ fontWeight: 'bold' }}>Pay only for results.</b>
//             </p>
//           </div>
//           <img src={homegif} style={{ width: '30%', marginLeft: 'auto' }} alt="Home GIF" />
//         </div>
//       </div>

//       {/* Search Bar with Icons and Buttons */}
//       <div
//         style={{
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'space-between',
//           border: '1px solid #ccc',
//           borderRadius: '5px',
//           padding: '5px',
//           maxWidth: '600px',
//           margin: '0 auto',
//           backgroundColor: '#fff',
//           borderRadius: '40px',
//         }}
//       >
//         {/* Social Media Icons */}
//         <div style={{ display: 'flex', alignItems: 'center', gap: '10px', paddingLeft: '20px' }}>
//           <a
//             href="https://instagram.com"
//             target="_blank"
//             rel="noopener noreferrer"
//             style={{ color: '#E4405F', fontSize: '24px' }}
//           >
//             <FaInstagram />
//           </a>
//           <a
//             href="https://youtube.com"
//             target="_blank"
//             rel="noopener noreferrer"
//             style={{ color: '#FF0000', fontSize: '24px' }}
//           >
//             <FaYoutube />
//           </a>
//         </div>

//         {/* Search Input and Button */}
//         <div style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
//           <input
//             type="text"
//             placeholder="Search..."
//             style={{
//               width: '100%',
//               padding: '10px',
//               border: 'none',
//               borderRadius: '5px 0 0 5px',
//               color: '#000000',
//               outline: 'none',
//             }}
//           />
//           <button
//             style={{
//               border: 'none',
//               padding: '10px 15px',
//               backgroundColor: '#007bff',
//               color: '#fff',
//               borderRadius: '0 5px 5px 0',
//               cursor: 'pointer',
//               alignItems: 'center',
//               fontSize: '16px',
//               borderRadius: '25px',
//             }}
//           >
//             Search
//           </button>
//         </div>
//       </div>

//       <div className="flex pt-8 text-lg" style={{ justifyContent: 'center' }}>
//         <NavLink to="/BrandIntro">
//           <div
//             className="mr-5 bg-yellow-300 px-7 py-3 hover:bg-gray-400 ease-in duration-200 rounded"
//             style={{ textAlign: 'center' }}
//           >
//             I'm a Brand
//           </div>
//         </NavLink>
//         <NavLink to="/InfluencerIntro">
//           <div
//             className="mr-5 bg-yellow-800 px-7 py-3 hover:bg-gray-400 ease-in duration-200 text-white rounded"
//             style={{ textAlign: 'center' }}
//           >
//             I'm a Creator
//           </div>
//         </NavLink>
//       </div>

//       {/* Slider Section */}
//       <div style={{ width: '90%', margin: '30px auto' }}>
//         <Slider {...settings}>
//           {Images.map((logo, index) => (
//             <div key={index} className="slide">
//               <img
//                 src={logo}
//                 alt={`Logo ${index + 1}`}
//                 style={{
//                   width: '100px',
//                   height: '50px',
//                   objectFit: 'contain',
//                   display: 'block',
//                   margin: 'auto',
//                 }}
//               />
//             </div>
//           ))}
//         </Slider>
//       </div>

//       {/* Hypebox for Brands Section */}
//       <div style={{ backgroundColor: '#FFD700', padding: '50px 20px', textAlign: 'center' }}>
//         <h2 style={{ fontSize: '32px', color: '#000', fontWeight: 'bold', marginBottom: '20px' }}>
//           HYPEBOX FOR BRANDS
//         </h2>

//         {/* Cards Container */}
//         <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '20px' }}></div>
//       </div>

//       {/* Footer */}
//       <FooterPage />
//     </div>
//   );
// };

// export default Home;



// rmeoevd hashed  





import React, { useEffect } from 'react';
import { FaInstagram, FaYoutube } from 'react-icons/fa';
import { NavLink } from 'react-router-dom';
import Slider from 'react-slick';
import { toast } from 'react-toastify';
import FooterPage from './components/FooterPage';
import Header from './components/Header';
import homegif from './Images/homegif.gif';

const Home = () => {
  useEffect(() => {
    // Get the current URL
    const currentUrl = window.location.href;

    // Remove any part after "#" (split the URL at "#")
    const cleanUrl = currentUrl.split('#')[0];  // This removes anything after `#`

    // Extract the query string from the cleaned URL (before the #)
    const queryParams = new URLSearchParams(cleanUrl.split('?')[1]);

    // Extract the auth code from the URL parameters
    const authCode = queryParams.get('code');

    if (authCode) {
      // If the URL contains 'code', send it to the backend to get an access token
      sendTokenRequest(authCode)
        .then((data) => {
          if (data?.access_token) {
            // Save the access token on your backend instead of localStorage
            saveAccessTokenToBackend(data.access_token, authCode); // Send the authCode too

            console.log('Access Token:', data.access_token);
            toast.success('Access token saved successfully');
          } else {
            toast.error('Failed to retrieve access token from backend');
          }
        })
        .catch((error) => {
          console.error('Error sending token request:', error);
          toast.error('Failed to fetch access token');
        });
    }
  }, []);

  const sendTokenRequest = (authCode) => {
    return fetch("https://server-side-influencer-production.up.railway.app/instagram/token", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        appId: '1366779784736329', // Your Instagram App Client ID
        appSecret: '079c7141825d53c3d8888a5c09ee71e9', // Your Instagram App Client Secret
        grant_type: 'authorization_code',
        redirectUri: 'https://influencer-marketing-hub.vercel.app/', // Your Redirect URI
        code: authCode, // Send the auth_code to get the access_token
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Token response:", data);
        return data;
      })
      .catch((error) => {
        console.error("Error fetching token:", error);
        throw error;
      });
  };

  // Save the access token and auth code to the backend
  const saveAccessTokenToBackend = (accessToken, authCode) => {
    return fetch('https://server-side-influencer-production.up.railway.app/save-access-token', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        access_token: accessToken, // Send the access_token
        auth_code: authCode,       // Send the auth_code too
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log('Access token saved to backend:', data);
      })
      .catch((error) => {
        console.error('Error saving access token to backend:', error);
      });
  };

  const Images = [
    "https://www.upfluence.com/wp-content/uploads/elementor/thumbs/Client-Logo-Netflix-quah560nq2rlgrugsu9vf81sgznpnc8uqcmrp27vbs.png",
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQaGtStAl2CAgEhUqKJFPnsHKrFKxUht2t68F2VkzO8xXeAqToU",
    "https://encrypted-tbn3.gstatic.com/images?q=tbn:ANd9GcSvVO6uW1MoLAPZcNxJK22DT9AE85EO3boos7ZZTThXc2iLOtnL",
  ];

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
  };

  return (
    <div style={{ backgroundColor: '#fff', padding: '20px' }}>
      <Header />

      {/* Hero Section */}
      <div style={{ width: '80%', margin: 'auto', marginTop: '40px' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ flex: 1 }}>
            <h1 style={{ fontSize: '36px', fontWeight: 'bold' }}>
              Hypebox generates sales to brands via micro-influencers
            </h1>
            <p style={{ fontSize: '18px', marginTop: '20px' }}>
              Generate sales, attract customers and increase brand awareness.{' '}
              <b style={{ fontWeight: 'bold' }}>Pay only for results.</b>
            </p>
          </div>
          <img src={homegif} style={{ width: '30%', marginLeft: 'auto' }} alt="Home GIF" />
        </div>
      </div>

      {/* Search Bar with Icons and Buttons */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          border: '1px solid #ccc',
          borderRadius: '5px',
          padding: '5px',
          maxWidth: '600px',
          margin: '0 auto',
          backgroundColor: '#fff',
          borderRadius: '40px',
        }}
      >
        {/* Social Media Icons */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', paddingLeft: '20px' }}>
          <a
            href="https://instagram.com"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#E4405F', fontSize: '24px' }}
          >
            <FaInstagram />
          </a>
          <a
            href="https://youtube.com"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#FF0000', fontSize: '24px' }}
          >
            <FaYoutube />
          </a>
        </div>

        {/* Search Input and Button */}
        <div style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
          <input
            type="text"
            placeholder="Search..."
            style={{
              width: '100%',
              padding: '10px',
              border: 'none',
              borderRadius: '5px 0 0 5px',
              color: '#000000',
              outline: 'none',
            }}
          />
          <button
            style={{
              border: 'none',
              padding: '10px 15px',
              backgroundColor: '#007bff',
              color: '#fff',
              borderRadius: '0 5px 5px 0',
              cursor: 'pointer',
              alignItems: 'center',
              fontSize: '16px',
              borderRadius: '25px',
            }}
          >
            Search
          </button>
        </div>
      </div>

      <div className="flex pt-8 text-lg" style={{ justifyContent: 'center' }}>
        <NavLink to="/BrandIntro">
          <div
            className="mr-5 bg-yellow-300 px-7 py-3 hover:bg-gray-400 ease-in duration-200 rounded"
            style={{ textAlign: 'center' }}
          >
            I'm a Brand
          </div>
        </NavLink>
        <NavLink to="/InfluencerIntro">
          <div
            className="mr-5 bg-yellow-800 px-7 py-3 hover:bg-gray-400 ease-in duration-200 text-white rounded"
            style={{ textAlign: 'center' }}
          >
            I'm a Creator
          </div>
        </NavLink>
      </div>

      {/* Slider Section */}
      <div style={{ width: '90%', margin: '30px auto' }}>
        <Slider {...settings}>
          {Images.map((logo, index) => (
            <div key={index} className="slide">
              <img
                src={logo}
                alt={`Logo ${index + 1}`}
                style={{
                  width: '100px',
                  height: '50px',
                  objectFit: 'contain',
                  display: 'block',
                  margin: 'auto',
                }}
              />
            </div>
          ))}
        </Slider>
      </div>

      {/* Hypebox for Brands Section */}
      <div style={{ backgroundColor: '#FFD700', padding: '50px 20px', textAlign: 'center' }}>
        <h2 style={{ fontSize: '32px', color: '#000', fontWeight: 'bold', marginBottom: '20px' }}>
          HYPEBOX FOR BRANDS
        </h2>

        {/* Cards Containers */}
        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '20px' }}></div>
      </div>

      {/* Footers */}
      <FooterPage />
    </div>
  );
};

export default Home;
